import { twMerge } from 'tailwind-merge';

export interface InputGroupProps {
  children: React.ReactNode;
  className?: string;
}

export const InputGroup = ({
  children,
  className,
  ...props
}: InputGroupProps) => {
  return (
    <div
      {...props}
      className={twMerge(
        'relative flex flex-col justify-center kunde:gap-y-3',
        className,
      )}
    >
      {children}
    </div>
  );
};

export default InputGroup;
